/* RepoExpansionPanelComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./RepoExpansionPanelRenderer");

class RepoExpansionPanelComponent extends EventEmitter {
    constructor(repo) {
        super();
        this._renderer = new Renderer(this);
        this.setRepo(repo);

        this._collapsed = true;

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._repo = undefined;
            this._renderer = undefined;
            this._collapsed = undefined;
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API DATA RETREIVAL METHODS */
    /*******************************************/
    /*** is private ***/
    //TODO Jake is advising that we dont try and model repo data access via a Tree structure
    //Instead we should have a sharing mechanism think google drive sharing...
    get private() {
        return this.isPrivate();
    }
    isPrivate() {
        return _.get(this._repo, "repository.private", false);
    }
    /*** name ***/
    get name() {
        return this.getName();
    }
    getName() {
        return _.get(this._repo, "repository.name");
    }
    /*** type ***/
    get type() {
        return this.getType();
    }
    getType() {
        return _.get(this._repo, "repository.type");
    }
    /*** uri ***/
    get uri() {
        return this.getUri();
    }
    getUri() {
        return _.get(this._repo, "repository.uri");
    }
    /*** description ***/
    get description() {
        return this.getDescription();
    }
    getDescription() {
        return _.get(this._repo, "repository.description");
    }
    /*** username ***/
    get userName() {
        return this.getUserName();
    }
    getUserName() {
        return _.get(this._repo, "repository.userName");
    }
    /*** REPO ***/
    get repo() {
        return this.getRepo();
    }
    getRepo() {
        return this._repo;
    }
    set repo(repo) {
        return this.setRepo(repo);
    }
    setRepo(repo, silent) {
        this._repo = repo;
        if (!silent) {
            this.emit("RepoReplaced");
        }
        return this;
    }
    /*** REPO Packages ***/
    get packages() {
        return this.getPackages();
    }
    getPackages() {
        let pkgs = _.cloneDeep(_.get(this._repo, "packages", []));
        //TODO Should this be provided to us by the back end?
        pkgs.forEach((pkg) => {
            pkg.repository = this.repo.repository;
        });
        return pkgs;
    }
    /*******************************************/
    /* END PUBLIC API DATA RETREIVAL METHODS */
    /* START PUBLIC API ACTION METHODS */
    /*******************************************/
    isExpanded() {
        return !this._collapsed;
    }
    expand() {
        this._collapsed = false;
        this.emit("RepoExpanded", this._repo);
    }
    isCollapsed() {
        return this._collapsed;
    }
    collapse() {
        this._collapsed = true;
        this.emit("RepoCollapsed", this._repo);
    }
    toggleCollapsed() {
        let isCollapsed = this.isCollapsed();
        //if collapsed
        if (isCollapsed) {
            this.expand();
        }
        //if expanded
        else {
            this.collapse();
        }
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /* START PUBLIC API ACTION METHODS */
    /*******************************************/
    launchEditor(editorState, editorName, opts) {
        this.emit("LaunchEditor", editorState, editorName, opts);
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /*******************************************/
}
module.exports = RepoExpansionPanelComponent;
